module.exports = __webpack_public_path__ + "img/special_arcade.5df5eda8.png";